import { render, staticRenderFns } from "./guahao_settlement.vue?vue&type=template&id=63a50a92&scoped=true&"
import script from "./guahao_settlement.vue?vue&type=script&lang=js&"
export * from "./guahao_settlement.vue?vue&type=script&lang=js&"
import style0 from "./guahao_settlement.vue?vue&type=style&index=0&id=63a50a92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a50a92",
  null
  
)

export default component.exports